import L from 'leaflet';

/**
 * Leaflet bug: Map.remove() deletes `_mapPane` but never resets
 * `_animatingZoom` or cancels the 250ms setTimeout that _animateZoom()
 * schedules for _onZoomTransitionEnd (leaflet-src.js, webkit transitionend
 * workaround). If a map is unmounted mid zoom-animation, that orphaned
 * timeout fires anyway, sees `_animatingZoom` still true, and unconditionally
 * calls `_move()` → `getPosition(this._mapPane)` → crashes on
 * `undefined._leaflet_pos`. Upstream's own guard only protects the
 * `removeClass` call, not the rest of the function.
 * https://github.com/Leaflet/Leaflet/issues/8783 (still open)
 *
 * Extend that same guard to the whole method. Call once at app startup,
 * before any map mounts.
 */
export function patchLeafletZoomTransitionCrash(): void {
  const proto = (L as any).Map.prototype;
  const original = proto._onZoomTransitionEnd;
  if (!original || (proto as any).__zoomTransitionEndPatched) return;

  proto._onZoomTransitionEnd = function patchedOnZoomTransitionEnd(this: any) {
    if (!this._mapPane) return;
    return original.apply(this, arguments);
  };
  (proto as any).__zoomTransitionEndPatched = true;
}
